import React, { useState } from 'react';

import { TestTypes } from '@/Models/Configuration';

import CTMonitoringBody from './CTMonitoringBody';
import CTMonitoringHeader from './CTMonitoringHeader';

export interface CTMonitoringPanelProps {
    isWebcamEnabled: boolean;
    isScreenSnapshotsEnabled: boolean;
    isFullScreenEnabled: boolean;
    testType: TestTypes;
}

function CandidateTestMonitoringPanel(props: CTMonitoringPanelProps): React.JSX.Element {
    const [isOpened, setIsOpened] = useState<boolean>(false);

    const togglePanel = () => {
        setIsOpened(!isOpened);
    };

    return (
        <div className="overflow-hidden rounded-lg">
            <div className="flex flex-col">
                <CTMonitoringHeader isOpened={isOpened} togglePanel={togglePanel} {...props} />
                <CTMonitoringBody isOpened={isOpened} {...props} />
            </div>
        </div>
    );
}

export default CandidateTestMonitoringPanel;
